import { c as _c } from "react/compiler-runtime";
import { Badge } from '@svenskaspelab/ui/react/badge';
import type { ReactNode } from 'react';
type SportinfoModalCouponResultProps = {
  result?: [number, number];
  isCancelled?: boolean;
};

/**
 * Component to render the result of a coupon in the sportinfo modal.
 *
 * @param root0 component props
 * @param root0.result result of the coupon as a tuple containing home and away scores
 * @param root0.isCancelled whether the coupon is cancelled
 * @returns Component for rendering the coupon result
 */
export function SportinfoModalCouponResult(t0) {
  const $ = _c(3);
  const {
    result,
    isCancelled
  } = t0;
  if (!result || isCancelled) {
    return;
  }
  const [homeScore, awayScore] = result;
  let t1;
  if ($[0] !== awayScore || $[1] !== homeScore) {
    t1 = <Badge className="align-center flex justify-center text-xs lg:text-sm" emphasis="low" variant="neutral">{homeScore} - {awayScore}</Badge>;
    $[0] = awayScore;
    $[1] = homeScore;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}